import React from 'react';
import { Service } from '../../services/utils';
import { ChartDataFetchErrorStyles } from '../../v2/common/components/charts/ChartDataFetchError';
import {
  useExecutorRoleContext,
  useSimulatedRoleContext,
} from '../../v2/context/contexts';
import { ApiMasterDataQueryFilterItem } from '../../v2/types';
import { ServiceExecutor } from './ServiceExecutor';

interface ServiceExecutorWithRolesProps<Inputs, Response> {
  children: (state: {
    data: Response | null;
    refetch: (offsetParams?: any) => Promise<void>;
  }) => React.ReactNode;
  service: Service<Inputs, Response>;
  inputs: Inputs;
  filters: ApiMasterDataQueryFilterItem[];
  withOffset?: boolean;
  styles?: {
    errorUI?: ChartDataFetchErrorStyles;
  };
}

export const ServiceExecutorWithRoles = <Inputs = any, Response = any>(
  props: ServiceExecutorWithRolesProps<Inputs, Response>
) => {
  const executorRole = useExecutorRoleContext();
  const simulatedRole = useSimulatedRoleContext();

  const inputsWithRoles = {
    ...props.inputs,
    executorRole,
    simulatedRole,
  } as Inputs;

  return (
    <ServiceExecutor
      service={props.service}
      inputs={inputsWithRoles}
      filters={props.filters}
      withOffset={props.withOffset}
      styles={props.styles}
    >
      {props.children}
    </ServiceExecutor>
  );
};

export default ServiceExecutorWithRoles;
